module.exports = __webpack_public_path__ + "img/02.19ba5ac3.png";